// Module
var code = `<fdx-modal-hoc modal-title="Shopify Setup Instructions" on-cancel="\$ctrl.onCancel()" submit-button="false" cancel-button="false"> <shopify-instructions></shopify-instructions> </fdx-modal-hoc>`;
// Exports
module.exports = code;